<template>
  <v-form ref="pushNotificationForm" v-model="valid" class="notification-page" @submit.prevent="save()">
    <v-row>
      <v-col cols="12">
        <h1>Уведомления (новый клиент)</h1>
        <h5>{NAME} - есть в текст надо вставить имя юзера. Промокод создаётся в 00 по серверу (03 по Украине) на день, если поменять что-то в настройках промокода, то старый промокод не изменится</h5>

        <v-tabs v-model="tab" class="mt-6">
          <v-tab>Настройки</v-tab>
          <v-tab @click="loadLogs">Лог</v-tab>
          <v-tab>Тест</v-tab>
        </v-tabs>
      </v-col>

      <v-col cols="12" sm="8" md="6" xl="4" v-if="loading">
        Загружаю...
      </v-col>
      <v-col cols="12" :sm="tab === 1 ? 12 : 8" :md="tab === 1 ? 12 : 6" :xl="tab === 1 ? 12 : 4" v-if="!loading">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-checkbox v-model="notification.on" label="Включен"></v-checkbox>
            <v-checkbox v-model="notification.debug" label="Debug режим"></v-checkbox>

            <v-img :src="previewImage(image)" width="246" height="195" class="mb-8">
              <template v-slot:placeholder>
                <div class="image-placeholder">
                  <img class="noimage-preview" src="@/assets/noImage.jpg"/>
                </div>
              </template>
            </v-img>
            <v-file-input
              label="Картинка"
              prepend-icon=""
              class="cursor-pointer"
              outlined
              placeholder="1768x1402"
              append-icon="mdi-attachment"
              @change="handleImage($event)"
              v-model="image"
            ></v-file-input>

            <v-textarea
              v-model="notification.text"
              label="Описание"
              :rules="[rules.required]"
              outlined
            ></v-textarea>
            <v-text-field
              v-model="notification.button"
              label="Кнопка"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-autocomplete
              v-model="notification.item"
              label="Блюдо промокода"
              :rules="[rules.required]"
              :items="products"
              item-value="id"
              item-text="name"
              outlined
            ></v-autocomplete>
            <v-text-field
              v-model="notification.minPrice"
              label="Минимальная сумма"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-autocomplete
              v-model="notification.itemCond"
              label="Блюдо-условие промокода"
              :items="products"
              item-value="id"
              item-text="name"
              outlined
            ></v-autocomplete>
            <v-text-field
              v-model="notification.viberLink"
              label="Ссылка на вайбер"
              :rules="[rules.required]"
              outlined
            ></v-text-field>

            <v-checkbox v-model="notification.remindOn" label="Напоминалка включена"></v-checkbox>
            <v-textarea
              v-model="notification.remindText"
              label="Описание напоминалки"
              :rules="[rules.required]"
              outlined
            ></v-textarea>
            <v-btn type="submit">Отправить</v-btn>
            <div v-if="saved || error" class="mt-3">
              <span class="green--text" v-if="saved">Сохранено успешно</span>
              <span class="red--text" v-if="error">Ошибка сохранения</span>
            </div>
          </v-tab-item>

          <v-tab-item>
            <v-btn type="button" class="mb-4" @click="loadLogs">Обновить</v-btn>
            <v-data-table
              :headers="logHeaders"
              :items="logs"
              :footer-props="logFooterProps"
              no-data-text="Лог пуст"
            >
              <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
              <template v-slot:item.user="{ item }">
                {{ item.user_id || item.phone || '-' }}
              </template>
              <template v-slot:item.type="{ item }">
                {{ item.is_reminder ? 'Напоминание' : 'Первое' }}
              </template>
              <template v-slot:item.message="{ item }">
                <span style="white-space: pre-line">{{ logMessage(item) }}</span>
              </template>
              <template v-slot:item.log_status="{ item }">
                {{ logStatus(item) }}
              </template>
              <template v-slot:item.log_response="{ item }">
                <span class="text-break">{{ item.log_response || '-' }}</span>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-autocomplete
              v-model="testUserId"
              :items="testUsers"
              :loading="testUsersLoading"
              :search-input.sync="testUserSearch"
              item-value="id"
              item-text="text"
              label="Пользователь"
              placeholder="Начните вводить email"
              no-data-text="Ничего не найдено"
              clearable
              outlined
            ></v-autocomplete>
            <v-radio-group v-model="testMessageType" row>
              <v-radio label="Первое сообщение" value="first"></v-radio>
              <v-radio label="Напоминалка" value="reminder"></v-radio>
            </v-radio-group>
            <v-btn type="button" :loading="testLoading" @click="sendTest">Отправить тест</v-btn>
            <div v-if="testResult" class="mt-3" :class="testResult.ok ? 'green--text' : 'red--text'">
              {{ testResultText }}
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import SettingService from "@/api/SettingService";
import ProductService from "@/api/ProductService";

export default {
  name: 'PushNewClientNotification',
  data: () => ({
    tab: 0,
    loading: false,
    image: null,
    notification: {
      id: 0,
      text: '',
      remindText: '',
      image: null,
      button: '',
      viberLink: '',
      item: null,
      minPrice: '',
      itemCond: null,
      on: false,
      remindOn: false,
      debug: false,
    },
    logs: [],
    logHeaders: [
      {text: 'ID', value: 'id'},
      {text: 'Дата', value: 'created_at'},
      {text: 'Канал', value: 'channel'},
      {text: 'Юзер', value: 'user'},
      {text: 'Тип', value: 'type'},
      {text: 'Статус', value: 'log_status'},
      {text: 'Ответ', value: 'log_response'},
      {text: 'Текст', value: 'message'},
    ],
    logFooterProps: {
      itemsPerPageOptions: [10, 25, 50, 100],
      itemsPerPageText: 'Строк на странице:',
      pageText: '{0}-{1} из {2}',
    },
    testUserId: '',
    testUserSearch: '',
    testUsers: [],
    testUsersLoading: false,
    testMessageType: 'first',
    testLoading: false,
    testResult: null,
    products: [],
    rules: {
      required: value => !!value || 'Нужно заполнить',
    },
    saved: false,
    error: false,
    valid: true,
  }),
  computed: {
    testResultText() {
      if (!this.testResult) return '';
      return this.testResult.ok
        ? `Отправлено через ${this.testResult.channel || 'канал'}`
        : `Ошибка: ${this.testResult.error || 'не удалось отправить'}`;
    }
  },
  mounted() {
    ProductService.list({}).then(response => {
      this.products = response.data;
      this.loading = false;
    });

    SettingService.get('push_first').then(response => {
      const notData = response.data;

      this.notification = {
        text: 'Вы получили промокод',
        remindText: 'Вы не активировали промокод',
        image: null,
        button: 'Текст кнопки',
        viberLink: 'Ссылка на вайбер',
        item: null,
        itemCond: null,
        minPrice: '300',
        on: false,
        remindOn: false,
        debug: false,
        id: notData.id,
        ...JSON.parse(notData.value)
      };
    });
  },
  watch: {
    testUserSearch(value) {
      this.searchTestUsers(value);
    }
  },
  methods: {
    searchTestUsers(query) {
      if (!query || query.length < 2) {
        this.testUsers = [];
        return;
      }

      this.testUsersLoading = true;
      SettingService.searchTestUsers(query)
        .then(response => {
          this.testUsers = response.data.users.map(user => ({
            id: user.id,
            text: `${user.email || 'без email'} / ${user.phone || 'без телефона'} / ID ${user.id}`,
          }));
        })
        .finally(() => {
          this.testUsersLoading = false;
        });
    },
    fileToBase64(image) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
        reader.readAsDataURL(image)
      })
    },
    async handleImage(e) {
      const file = e;
      if (!file) return

      try {
        const response = await SettingService.uploadPushFirstImage(file)
        this.notification.image = response.data.image
        this.image = null
      } catch (err) {
        console.error('Ошибка конвертации:', err)
      }
    },
    previewImage(image) {
      if (!this.notification.image && image) {
        return URL.createObjectURL(image)
      }

      if (this.notification.image && this.notification.image.indexOf('http') !== 0 && this.notification.image.indexOf('data:image/') !== 0) {
        const imagePath = this.notification.image.replace(/^\/+/, '');
        const prefix = imagePath.indexOf('storage/') === 0 || imagePath.indexOf('img/') === 0 ? '/' : '/img/notifications/';

        return process.env.VUE_APP_BACKEND_URL.replace(/\/api\/?$/, '') + prefix + imagePath
      }

      return this.notification.image
    },
    loadLogs() {
      SettingService.debugLogs('push_first').then(response => {
        this.logs = response.data;
      });
    },
    logMessage(log) {
      if (log.channel === 'viber') {
        return log.text || '';
      }

      return [log.title, log.text].filter(Boolean).join('\n');
    },
    logStatus(log) {
      if (log.log_status === 'debug') return 'Debug';
      if (log.log_status === 'sent') return 'Отправлено';
      if (log.log_status === 'error') return 'Ошибка';

      return '-';
    },
    formatDate(value) {
      if (!value) return '-';

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return new Intl.DateTimeFormat('uk-UA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    },
    sendTest() {
      this.testResult = null;
      this.testLoading = true;

      SettingService.testSend('push_first', this.testUserId, {message_type: this.testMessageType})
        .then(response => {
          this.testResult = response.data;
        })
        .catch(error => {
          this.testResult = {
            ok: false,
            error: error.response && error.response.data ? JSON.stringify(error.response.data) : error.message
          };
        })
        .finally(() => {
          this.testLoading = false;
        });
    },
    save() {
      this.$refs.pushNotificationForm.validate();
      this.saved = false;
      this.error = false;

      if (this.valid) {
        SettingService.update(this.notification.id, {value: this.notification}).then(response => {
          this.notification = {...this.notification, ...JSON.parse(response.data.value)};
          this.image = null;
          this.saved = true;
        }).catch(error => {
          console.error(error);
          this.error = true;
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.notification-page {
  padding-bottom: 32px;
}
</style>
